import { useCallback } from "react";
import * as ai from "../lib/ai";
import * as db from "../lib/db";
import { saveRunPlan, deleteRunPlan } from "../utils/run-plan";
import { useToast } from "./useToast";

export function useRunActions({ userId, setRuns, setRunPlan, setRunPlanLoading }) {
  const toast = useToast();

  const handleGenerateRunPlan = useCallback(async (config) => {
    if (!userId) return;
    setRunPlanLoading(true);
    try {
      const result = await ai.generateRunPlan(userId, config);
      saveRunPlan(userId, result);
      setRunPlan(result);
      toast.success(`${config.race_type} plan created`);
    } catch (e) {
      console.error("Failed to generate run plan:", e);
      toast.error(e.message || "Failed to generate training plan");
    }
    setRunPlanLoading(false);
  }, [userId, setRunPlan, setRunPlanLoading, toast]);

  const handleDeleteRunPlan = useCallback(async () => {
    if (!userId) return;
    await deleteRunPlan(userId);
    setRunPlan(null);
    toast.info("Training plan deleted");
  }, [userId, setRunPlan, toast]);

  const handleDeleteRun = useCallback(async (id) => {
    setRuns((prev) => prev.filter((r) => r.id !== id));
    try {
      await db.deleteRun(id);
    } catch (e) {
      console.error("Failed to delete run:", e);
    }
  }, [setRuns]);

  return { handleGenerateRunPlan, handleDeleteRunPlan, handleDeleteRun };
}
